
  document.addEventListener('DOMContentLoaded', () => {
    const collectionsLayout = document.querySelectorAll('.collections-layout__text .collection-item');
    const collectionsLayoutImg = document.querySelectorAll('.collections-layout__img .collection-item__image');
    
    collectionsLayout.forEach((collection, index) => {
      collection.addEventListener('mouseover', () => {
        collectionsLayoutImg.forEach(img => img.classList.remove('active'));
        collectionsLayoutImg[index].classList.add('active');
      });
      
      collection.addEventListener('mouseout', () => {
        collectionsLayoutImg.forEach(img => img.classList.remove('active'));
        setTimeout(() => {
          collectionsLayoutImg[0].classList.add('active');
        }, 300);
      });
    });
  });
